/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
const baseSchema = z.object({
    latitude: z.number(),
    longitude: z.number(),
}
).strict();
export const LatitudeLongitudeSchema = baseSchema;
